import React from 'react';

import { useLogger } from '@/shared/hooks/useLogger';

import { ControlErrorBoundary, ControlErrorBoundaryProps } from './component';

export function withControlErrorBoundary<Props extends {}>(
    Component: React.ComponentType<Props>,
    errorBoundaryProps: Omit<ControlErrorBoundaryProps, 'logger'> = {}
): React.ComponentType<Props> {
    const name = Component.displayName || Component.name || 'Unknown';

    const Wrapped: React.ComponentType<Props> = (props) => {
        const logger = useLogger();

        return (
            <ControlErrorBoundary {...errorBoundaryProps} logger={logger}>
                <Component {...props} />
            </ControlErrorBoundary>
        );
    };

    Wrapped.displayName = `withControlErrorBoundary(${name})`;

    return Wrapped;
}
